import KunLoading109 from './src/index'

KunLoading109.install = function (Vue) {
	Vue.component(KunLoading109.name, KunLoading109);
}

export default KunLoading109;
